const menuToggle = () => {
  const body: Element = document.querySelector('body');
  const header: Element = document.querySelector('.header');
  const toggler: Element = header.querySelector('.header__toggler');

  const bodyActive: string = 'overflow-hidden';
  const headerActive: string = 'header--active';

  toggler.addEventListener('click', () => {
    body.classList.toggle(bodyActive);
    header.classList.toggle(headerActive);
  });
};

export default menuToggle;
